import React from "react";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Species } from "../types/species";

interface SpeciesSearchProps {
  selectedSpecies: Species | null;
  onSpeciesSelect: (species: Species | null) => void;
  onSearch: () => void;
  species: Species[];
  onFilter: (filter: string) => void;
  loadingSpecies: boolean;
  loadingSpeciesToShow: boolean;
}

export const SpeciesSearch = ({
  selectedSpecies,
  onSpeciesSelect,
  onSearch,
  species,
  onFilter,
  loadingSpecies,
  loadingSpeciesToShow,
}: SpeciesSearchProps) => {
  return (
    <div className="flex justify-content-center w-full">
      <div className="flex flex-column md:flex-row align-items-center justify-content-center gap-2 mb-3 w-full md:w-8">
        <Dropdown
          value={selectedSpecies}
          onChange={(e) => onSpeciesSelect(e.value)}
          options={species}
          optionLabel="name"
          placeholder="Select a Species"
          className="w-full md:w-20rem"
          loading={loadingSpecies}
          filter
          onFilter={(e) => {
            if (e.filter) {
              onFilter(e.filter);
            }
          }}
          disabled={loadingSpecies || loadingSpeciesToShow}
        />
        <Button
          onClick={onSearch}
          loading={loadingSpeciesToShow}
          disabled={!selectedSpecies || loadingSpeciesToShow}
          className="w-full md:w-auto flex align-items-center justify-content-center"
          style={{ minWidth: 100 }}
        >
          {!loadingSpeciesToShow && "Search"}
        </Button>
      </div>
    </div>
  );
};
